<ng-container *ngIf="messages$ | async as messages">
    <div class="messages">
        <div *ngFor="let message of messages; trackBy: trackByUuid" @Grow>
            <div class="pb-2 lg:inline-block">
                <app-message [message]="message"></app-message>
            </div>
        </div>
    </div>
</ng-container>
